<template>
    <div id="recipes-category-list" class="page recipes-category-list filter-category-menu">            
        <RecipesCategoryMenu />        
        <section>             
            <div class="container-xl recipes-category-list__content">
                <div class="row ">            
                    <div class="col-12  recipes-category-list__list-wrap" v-if="getDataSuccess">
                        <div class="recipes-category-list__list row" v-if="currentCategoryRecipes.length > 0">
                            <div class="col-12 col-sm-6 col-lg-4 recipes-item-wrap" v-for="recipe in currentCategoryRecipes" :key="recipe.id + '_' + currentLangName()">
                                <RecipeItem  
                                    :name="recipe.name"
                                    :id="recipe.id"                                  
                                    :recipe_slug="recipe.slug" 
                                    :srcset="itemSrcset(recipe)" 
                                    :src="itemSrc(recipe, 'w640h493')" 
                                    :difficulty="recipe.difficulty"
                                    :dish="recipe.dish"
                                    :making_time="recipe.making_time"                                     
                                />                 
                            </div>
                        </div>  
                        <div v-else class="no-result">{{lang('nincs_talalat')}}</div>
                    </div>
                    <div v-else class="col-12">
                        <Loading />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from 'axios'
import RecipeItem from '@/components/pagesComponents/recipes/RecipeItem.vue'
import RecipesCategoryMenu from '@/components/pagesComponents/recipes/RecipesCategoryMenu.vue' 
import Loading from '@/components/layoutComponents/Loading.vue'

export default {
    data(){
        return {
            currentCategoryRecipes: [],
            currentCategoryName: '',
            currentCategoryId: '',
            getDataSuccess: false,
            currentCategoryMetas: {
                meta_description: null,
                meta_image: null,
                meta_keywords: null,
                meta_title: null
            }       
        }
    },
    components:{
        RecipeItem,
        RecipesCategoryMenu,
        Loading        
    },
    computed:{
        recipesCategory(){            
            return this.$store.getters.getRecipesCategory;             
        },
        currentRecipeCatSlug(){
            return this.$route.params.recipes_category_slug;
        }
    },
    watch:{               
        recipesCategory: function(){
            this.getRecipes();            
        },
        $route: function(){                
            this.getRecipes();           
        }                    
    },
    methods:{
        getRecipes(){
            let currentRouteName = this.$route.name.substring(0, this.$route.name.indexOf('_'))        
            
            if ( currentRouteName == 'RecipesCategoryListAll'){
                this.getAllRecipes()
            } else {
                if (this.recipesCategory.length > 0){
                    this.getActualRecipesList()
                }
                
            }
        },
        getActualRecipesList(){
            // console.log("recept kategória slug", this.currentRecipeCatSlug)
            let _this = this
            let currentCategorySlug = this.currentRecipeCatSlug;
            let currentCategoryId = null;
            let currentCategoryName = null;

            this.recipesCategory.filter(item => {                
                if (item.slug == currentCategorySlug){
                    currentCategoryId = item.category_id,
                    currentCategoryName = item.name
                }
            })          
            
            this.currentCategoryId = currentCategoryId;
            
            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/category/' + currentCategoryId + '?relations=1&relations_params[information][where][0][0]=where&relations_params[information][where][0][1]=status&relations_params[information][where][0][2]=1&relations_params[information][order_by][0][0]=sort_order&relations_params[information][order_by][0][1]=asc&relations_params[information][order_by][1][0]=name&relations_params[information][order_by][1][1]=asc',{            
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {                
                
                if (response.data.status == true ){
                    // console.log('Adott kategória receptjei: ', response.data.category[0].information); 
                    if (response.data.category[0].information){
                        //this.currentCategoryRecipes = response.data.category[0].information;
                        
                         this.currentCategoryRecipes = [];
                             if (_this.$store.state.needPD){
                                for (var i=0; i <response.data.category[0].information.length ;i++)
                                {
                                    if (response.data.category[0].information[i].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                                          this.currentCategoryRecipes.push(response.data.category[0].information[i]);
                                }
                                
                            }
                            else
                                this.currentCategoryRecipes = response.data.category[0].information;

                        this.currentCategoryName = currentCategoryName;
                        this.getDataSuccess = true
                    } else {
                        this.currentCategoryRecipes = []
                        this.getDataSuccess = true
                    }

                    if (response.data.category[0].meta_description != ''){
                        _this.currentCategoryMetas.meta_description = response.data.category[0].meta_description
                    } else {
                        _this.currentCategoryMetas.meta_description = null
                    }                       

                    if ( !response.data.category[0].meta_image ) {  
                        _this.currentCategoryMetas.meta_image = null
                    } else {
                        let meta_image_src = process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME + '/' + response.data.category[0].meta_image.path + response.data.category[0].meta_image.file_name
                        _this.currentCategoryMetas.meta_image = meta_image_src
                    }
                    
                    if (response.data.category[0].meta_keywords != ''){
                        _this.currentCategoryMetas.meta_keywords = response.data.category[0].meta_keywords
                    } else {
                        _this.currentCategoryMetas.meta_keywords = null
                    }
                    
                    if (response.data.category[0].meta_title != '') {
                        _this.currentCategoryMetas.meta_title = response.data.category[0].meta_title
                    } else {
                        _this.currentCategoryMetas.meta_title = null
                    }          
                    
                    _this.setCurrentMetaTags() 
                    
                } else {
                    this.currentCategoryRecipes = []
                    this.getDataSuccess = false
                    this.$router.push({name: '404-page'})
                }                                                              
            })
            .catch((err) => {
                console.log(err)
            }); 

            
        },  
        getAllRecipes(){
            let _this = this

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/information?relations=1&where[0][0]=where&where[0][1]=type&where[0][2]=recipe&where[1][0]=where&where[1][1]=status&where[1][2]=1&order_by[0][0]=sort_order&order_by[0][1]=asc&order_by[1][0]=name&order_by[1][1]=asc',{            
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {
                // console.log("receptek", response.data)
                if (response.data.status == true ){                    
                    if (response.data.information){
                        //this.currentCategoryRecipes = response.data.information; 
                        this.currentCategoryRecipes = [];
                        if (_this.$store.state.needPD){
                            for (var i=0; i <response.data.information.length ;i++)
                            {
                                if (response.data.information[i].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                                        this.currentCategoryRecipes.push(response.data.information[i]);
                            }
                            
                        }
                        else
                            this.currentCategoryRecipes = response.data.information;
                        this.getDataSuccess = true                                             
                    } else {
                        this.currentCategoryRecipes = []
                        this.getDataSuccess = true
                    }
                                                          
                } else {
                    this.currentCategoryRecipes = []
                    this.getDataSuccess = true                    
                } 
                
                //set META TAGS                    
                this.setMetaTags({
                    title: _this.lang("title_receptek"), 
                    desc: _this.lang('meta_description_receptek'), 
                    keywords: _this.lang('meta_keywords_receptek'), 
                    ogType: 'article', 
                    ogTitle: _this.lang("title_receptek"),
                    ogImage: null, 
                    ogImageWidth: null, 
                    ogImageHeight: null, 
                    ogDesc: _this.lang('meta_description_receptek')
                })  
            })
            .catch((err) => {
                console.log(err)
            }); 
        },
        setCurrentMetaTags(){
            let _this = this            

            this.setMetaTags({
                title: _this.currentCategoryMetas.meta_title, 
                desc: _this.currentCategoryMetas.meta_description, 
                keywords: _this.currentCategoryMetas.meta_keywords, 
                ogType: 'article', 
                ogTitle: _this.currentCategoryMetas.meta_title,
                ogImage: _this.currentCategoryMetas.meta_image, 
                ogImageWidth: null, 
                ogImageHeight: null, 
                ogDesc: _this.currentCategoryMetas.meta_description
            })
        }          
    } ,
    created(){
         this.getRecipes();                
    }     
}
</script>